<ng-container *ngIf="showHeader">
    <div class="flex justify-between items-center px-[24px] h-12 border-t-2 border-t-gray-300">
        <p class="flex-1"></p>
        <p class="flex-1 title">{{ headerTitles[1] }}</p>
        <p class="flex-1 text-end title" [ngClass]="{'mr-[5px]': !(headerTitles[2] | valueIsNegativePipe)}"> {{ (headerTitles[2] | valueIsNegativePipe) ? '(' + (headerTitles[2] | stripNegativeSignPipe | formatNumber) + ')' : headerTitles[2] | formatNumber }}</p>
    </div>
</ng-container>

<mat-accordion>
    <ng-container *ngIf="data?.length">
        <mat-expansion-panel #panel *ngFor="let record of data; let i = index">

            <mat-expansion-panel-header>
                <p class="flex gap-[20px] flex-1">
                    <img class="accordImg w-[15px]" src="assets/icons/plus-icon.svg" alt="" *ngIf="!panel.expanded">
                    <img class="accordImg w-[15px]" src="assets/icons/minus-icon.svg" alt="" *ngIf="panel.expanded">
                </p>

                <ng-container *ngIf="!record">
                    <p class="text-center text-sm" i18n="@@no_records_found">No Records</p>
                </ng-container>
                <p class="flex-1 subtitle">{{ record?.label| titlecase }}</p>
                <p class="flex-1 text-end subtitle" [ngClass]="{'mr-[5px]': !(record?.runningBalance | valueIsNegativePipe)}">{{ (record?.runningBalance | valueIsNegativePipe) ? '(' + (record?.runningBalance | stripNegativeSignPipe | formatNumber) + ')' : record?.runningBalance | formatNumber }}</p>
            </mat-expansion-panel-header>

            <ng-container *ngIf="record?.child?.length">
                <mat-expansion-panel #childPanel *ngFor="let childRec of record?.child; let i = index">

                    <mat-expansion-panel-header>
                        <p class="flex gap-[20px] flex-1">
                            <img class="accordImg w-[15px]" src="assets/icons/plus-icon.svg" alt="" *ngIf="!childPanel.expanded">
                            <img class="accordImg w-[15px]" src="assets/icons/minus-icon.svg" alt="" *ngIf="childPanel.expanded">
                        </p>

                        <ng-container *ngIf="!record">
                            <p class="text-center text-sm" i18n="@@no_records_found">No Records</p>
                        </ng-container>
                        <p class="flex-1 subtitle2">{{ childRec?.label| titlecase }}</p>
                        <p class="flex-1 text-end subtitle2" [ngClass]="{'mr-[5px]': !(childRec?.runningBalance | valueIsNegativePipe)}">{{ (childRec?.runningBalance | valueIsNegativePipe) ? '(' + (childRec?.runningBalance | stripNegativeSignPipe | formatNumber) + ')' : childRec?.runningBalance | formatNumber }}</p>
                    </mat-expansion-panel-header>

                    <div class="panel-content flex items-center justify-between pl-10 pr-4 h-10 my-4" *ngFor="let gl of childRec.gls">
                        <p class="flex-1 content">{{ gl?.glCode }}</p>
                        <p class="flex-1 content">{{ gl?.glAccountName }}</p>
                        <p class="flex-1 text-end content" [ngClass]="{'mr-[5px]': !(gl?.runningBalance | valueIsNegativePipe )}">{{ (gl?.runningBalance | valueIsNegativePipe) ? '(' + (gl?.runningBalance | stripNegativeSignPipe | formatNumber) + ')' : gl?.runningBalance | formatNumber }}</p>
                    </div>
                </mat-expansion-panel>
            </ng-container>
        </mat-expansion-panel>
    </ng-container>
</mat-accordion>

<div class="flex justify-between items-center px-[24px] pr-[15px] h-12 border-t-2 border-b-2 border-t-gray-300 border-b-gray-300" *ngIf="showFooter">
    <p class="flex-1">{{ footerTitles[0] }}</p>
    <p class="flex-1 title">{{ footerTitles[1] }}</p>
    <p class="flex-1 text-end title" [ngClass]="{'mr-[5px]': !(footerTitles[2] | valueIsNegativePipe)}">{{ (footerTitles[2] | valueIsNegativePipe) ? '(' + (footerTitles[2] | stripNegativeSignPipe | formatNumber) + ')' : footerTitles[2] | formatNumber }}</p>
</div>